import { render, staticRenderFns } from "./MedicalRecord.vue?vue&type=template&id=cd951256&scoped=true"
import script from "./MedicalRecord.vue?vue&type=script&lang=js"
export * from "./MedicalRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd951256",
  null
  
)

export default component.exports